<div class="flex justify-between mb-4">
  <div class="text-xl text-gray-700 font-bold">Tarifário</div>
  <div class="mr-8 gap-2 flex justify-center">
<!--    @if (checkPermission('criar')) {-->
<!--      <button mat-raised-button class="btn-add" (click)="importTariff()">-->
<!--        Importar-->
<!--        <mat-icon>upload_file</mat-icon>-->
<!--      </button>-->
<!--    }-->
    @if (checkPermission('criar')) {
      <button mat-raised-button class="btn-add" (click)="newTariff()">
        Novo
        <mat-icon>add</mat-icon>
      </button>
    }
  </div>
</div>

<div class="mt-8">
  <div class="mt-4">
    <!--      <form-search [search]="inputSearch" (responseSearch)="search($event)" />-->
    <!--    @if (checkPermission('pesquisar-paginado')) {-->
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title> Pesquisa </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <search-tariff-page
            [searchEvent]="inputSearch"
            (responseSearch)="search($event)"
          />
          <!--            <form-search-proposal-client-->
          <!--              [search]="inputSearch"-->
          <!--              (responseSearch)="search($event)"-->
          <!--            />-->
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <!--    }-->
    <div class="mt-4">
      @if (!loading) {
        <div>
          <table-list-tariff
            [dataSource]="itemsList"
            [columns]="columns"
            (selectItem)="editItem($event)"
            (deleteItem)="deleteItem($event)"
            (changeStatusItem)="changeStatusItem($event)"
          />
          @if (itemsList.length > 0) {
            <mat-paginator
              [length]="numberRows"
              [pageSize]="rows"
              [pageIndex]="page - 1"
              [pageSizeOptions]="[5, 10, 20, 30]"
              (page)="onPageEvent($event)"
            >
            </mat-paginator>
          }
        </div>
      } @else {
        <div>
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      }
    </div>
  </div>
</div>
